<section id="values" class="values">
  <div class="container">
    <div class="section-title" data-aos="fade-up">
      <h2>{{ lastCompletedContestYear }} DART Student Art Contest Winners</h2>
      <div class="row justify-content-center">
        <div class="col-md-8 d-flex justify-content-center" data-aos="fade-up">
          <div class="card-body">
            <div class="card-text">
              <p class="card-text" *ngFor="let winner of bestOfShow">
                <b>
                  {{ winner.firstName }} {{ winner.lastName }} ({{ winner.voteChoice }}) – {{ winner.grade }} – {{ winner.schoolName }}
                  {{ winner.isd ? ' – ' + winner.isd : '' }}
                </b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">

      <div class="col-md-6 d-flex align-items-stretch" data-aos="fade-up">
        <div>
          <div class="card-body">
            <h5 class="card-title">K-2 Category</h5>
            <div class="card-text">
              <p class="card-text" *ngFor="let winner of winnersKto2">
                <b>{{ winner.firstName }} {{ winner.lastName }}</b> ({{ winner.voteChoice }}) – {{ winner.grade }} – {{ winner.schoolName }}
                {{ winner.isd ? ' – ' + winner.isd : '' }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 d-flex align-items-stretch mt-4 mt-md-0" data-aos="fade-up" data-aos-delay="100">
        <div>
          <div class="card-body">
            <h5 class="card-title">3rd – 5th Grade Category</h5>
            <div class="card-text">
              <p class="card-text" *ngFor="let winner of winners3to5">
                <b>{{ winner.firstName }} {{ winner.lastName }}</b> ({{ winner.voteChoice }}) – {{ winner.grade }} – {{ winner.schoolName }}
                {{ winner.isd ? ' – ' + winner.isd : '' }}
              </p>
            </div>
          </div>
        </div>

      </div>

      <div class="col-md-6 d-flex align-items-stretch mt-4" data-aos="fade-up" data-aos-delay="200">
        <div>
          <div class="card-body">
            <h5 class="card-title">6th-8th Grade Category</h5>
            <div class="card-text">
              <p class="card-text" *ngFor="let winner of winners6to8">
                <b>{{ winner.firstName }} {{ winner.lastName }}</b> ({{ winner.voteChoice }}) – {{ winner.grade }} – {{ winner.schoolName }}
                {{ winner.isd ? ' – ' + winner.isd : '' }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 d-flex align-items-stretch mt-4" data-aos="fade-up" data-aos-delay="300">
        <div>
          <div class="card-body">
            <h5 class="card-title">9th-12th Grade Category</h5>
            <div class="card-text">
              <p class="card-text" *ngFor="let winner of winners9to12">
                <b>{{ winner.firstName }} {{ winner.lastName }}</b> ({{ winner.voteChoice }}) – {{ winner.grade }} – {{ winner.schoolName }}
                {{ winner.isd ? ' – ' + winner.isd : '' }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>
